/* eslint-disable no-undef */

const TAG = 'GTAG';

function track(event, data) {
  try {
    gtag('event', event, data);
  } catch (error) {
    // GTAG should not be defined
    setTimeout(() => {
      try {
        gtag('event', event, data);
      } catch (e) {
        console.log(TAG, event, error);
      }
    }, 3000);
  }
}

const Gtag = {
  pageView(pageLocation, pagePath, pageTitle) {
    track('page_view', {
      page_location: pageLocation,
      page_path: pagePath,
      page_title: pageTitle,
    });
  },

  orderSend(price, currency, externalOrderId, shipping, items, promoCode = undefined) {
    track('purchase', {
      transaction_id: externalOrderId,
      affiliation: 'MyCanvas',
      value: price,
      currency,
      shipping,
      coupon: promoCode,
      items: items.map(item => ({
        id: item.id,
        name: item.name,
        quantity: item.quantity,
        price: item.single,
        brand: 'MyCanvas',
      })),
    });
  },

  customEvent(action, label = undefined, category = undefined, value = undefined) {
    track(action, {
      event_label: label,
      event_category: category,
      value,
    });
  },
};

export default Gtag;
